import { useState, useEffect } from 'react';
import Select from 'react-select';

import Button from '../../../../../reusable/button/button.component';

import {
  Col,
  Row,
  Input,
  Label,
  RemoveCol
} from './button-input-row.styles.jsx';

const linkTypeOptions = [
  { value: 'external', label: 'External' },
  { value: 'internal', label: 'Internal' }
];

const internalPathOptions = [
  { value: '/login', label: 'Login' },
  { value: '/sign-up', label: 'Sign Up' },
  { value: '/shop', label: 'Shop' }
];

const ButtonInputRow = ({
  data = {},
  index,
  update = () => {},
  remove = () => {},
  canRemove = false
}) => {
  const [text, setText] = useState(data.text || '');
  const [linkType, setLinkType] = useState(data.linkType || 'external');
  const [link, setLink] = useState(data.link || '');

  useEffect(() => {
    const finalLink =
      linkType === 'external' && link && !link.startsWith('http')
        ? `https://${link}`
        : link;

    update({
      text,
      linkType,
      link: finalLink
    });
  }, [text, linkType, link]);

  const handleLinkTypeChange = (selected) => {
    setLinkType(selected.value);
    setLink(''); // Reset link when type changes
  };

  const handleInternalLinkChange = (selected) => {
    setLink(selected.value);
  };

  return (
    <Row>
      <Col>
        <Label>Button Text</Label>
        <Input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Button Text - Click Here"
        />
      </Col>

      <Col>
        <Label>Link Type</Label>
        <Select
          value={linkTypeOptions.find(opt => opt.value === linkType)}
          onChange={handleLinkTypeChange}
          options={linkTypeOptions}
        />
      </Col>

      <Col>
        <Label>{linkType === 'external' ? 'URL' : 'Internal Path'}</Label>
        {linkType === 'external' ? (
          <Input
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="https://example.com"
          />
        ) : (
          <Select
            value={internalPathOptions.find(opt => opt.value === link)}
            onChange={handleInternalLinkChange}
            options={internalPathOptions}
            placeholder="Select internal route..."
          />
        )}
      </Col>

      {canRemove && (
        <RemoveCol>
          <Button onClick={remove} variant="danger">
            Remove
          </Button>
        </RemoveCol>
      )}
    </Row>
  );
};

export default ButtonInputRow;